var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarketing = function SvgMarketing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 164,
    height: 138,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#marketing_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#marketing_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2EB67D",
    d: "M105.295 114.398c0-7.287 5.939-13.193 13.266-13.193 7.326 0 13.266 5.906 13.266 13.193 0 7.286-5.94 13.192-13.266 13.192-7.327 0-13.266-5.906-13.266-13.192Z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#marketing_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFB800",
    d: "M29.573 44.95c0-4.73 3.855-8.563 8.61-8.563 4.755 0 8.61 3.834 8.61 8.563 0 4.728-3.855 8.562-8.61 8.562-4.755 0-8.61-3.834-8.61-8.562Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.986 40.292c.326 0 .589.261.589.584v.455a2.726 2.726 0 0 1 2.155 2.658v2.336l.506.501a.39.39 0 0 1-.279.666h-5.946a.389.389 0 0 1-.274-.666l.506-.502V43.99c0-1.303.924-2.393 2.155-2.658v-.455c0-.323.263-.584.588-.584ZM39.108 48.102c0 .296-.117.58-.328.789a1.125 1.125 0 0 1-1.587 0 1.112 1.112 0 0 1-.328-.79H39.108Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "m69.762 130.052 7.99-4.206-12.254-23.008-10.106 5.32 14.37 21.894Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "m55.392 108.158 5.48 8.352 8.896 13.542 7.99-4.206-12.254-23.014-10.112 5.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m55.392 108.158 5.48 8.352 8.896 13.542 7.99-4.206-12.254-23.014-10.112 5.326Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m55.392 108.158 3.611 5.509 10.231-3.822-3.73-7.013-10.112 5.326Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "m56.258 112.197 12.58-6.624-5.059-9.502-12.58 6.623 5.06 9.503Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m56.258 112.197 12.58-6.624-5.059-9.502-12.58 6.623 5.06 9.503Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "m40.932 103.664 10.285-4.176-8.185-15.377-9.252 6.117 7.152 13.436Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m40.932 103.664 10.285-4.176-8.185-15.377-9.252 6.117 7.152 13.436Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "m46.437 78.42 12.08 22.69 17.438-6.677 45.542-6.128-29.013-54.5-30.693 34.027L46.437 78.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2C9DE",
    d: "m46.437 78.42 12.08 22.69 17.438-6.677 45.542-6.128-29.013-54.5-30.693 34.027L46.437 78.42Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m121.503 88.305-45.549 6.122-17.437 6.683-3.083-5.828c5.337-1.462 19.387-5.308 19.702-5.308l46.367-1.67Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M122.461 87.984c4.889-2.575 2.325-16.923-5.728-32.049-8.053-15.125-18.545-25.3-23.434-22.725-4.89 2.574-2.325 16.923 5.728 32.048 8.053 15.126 18.545 25.3 23.434 22.726Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M100.84 63.692c7.147 13.424 16.191 22.601 20.165 20.496 3.974-2.106 1.453-14.704-5.693-28.129-7.147-13.424-16.168-22.601-20.142-20.49-3.973 2.112-1.476 14.698 5.67 28.123Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M102.021 63.072c.955 1.77 1.939 3.498 2.965 5.114a6.186 6.186 0 0 0 5.971-2.107 6.116 6.116 0 0 0 .695-6.805l-1.37-2.566a6.158 6.158 0 0 0-2.373-2.458 6.2 6.2 0 0 0-6.579.247 6.146 6.146 0 0 0-2.18 2.63 80.457 80.457 0 0 0 2.871 5.945Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M102.021 63.072c.955 1.77 1.939 3.498 2.965 5.114a6.186 6.186 0 0 0 5.971-2.107 6.116 6.116 0 0 0 .695-6.805l-1.37-2.566a6.158 6.158 0 0 0-2.373-2.458 6.2 6.2 0 0 0-6.579.247 6.146 6.146 0 0 0-2.18 2.63 80.457 80.457 0 0 0 2.871 5.945Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "m50.344 107.025 19.893-8.074-15.83-29.733-17.899 11.826 13.836 25.981Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m50.344 107.025 19.893-8.074-15.83-29.733-17.899 11.826 13.836 25.981Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M91.292 36.56c-.593 2.465-.41 5.049-.101 7.55.367 2.51.932 4.986 1.69 7.408.344 1.22.801 2.406 1.216 3.604.416 1.197.92 2.359 1.423 3.538.504 1.18 1.008 2.36 1.572 3.463.564 1.103 1.097 2.282 1.684 3.403a83.494 83.494 0 0 0 8.162 12.823 43.52 43.52 0 0 0 5.207 5.556c1.939 1.622 4.05 3.173 6.524 3.869-2.402-.85-4.431-2.436-6.269-4.129a43.047 43.047 0 0 1-5.006-5.633 88.463 88.463 0 0 1-7.96-12.81 91.014 91.014 0 0 1-6.043-13.85 48.493 48.493 0 0 1-1.874-7.295 21.812 21.812 0 0 1-.225-7.497Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M111.474 27.034c-.901 1.34-1.731 2.72-2.55 4.13a203.325 203.325 0 0 0-2.373 4.187 112.625 112.625 0 0 0-2.229 4.27l-1.068 2.159c-.332.731-.682 1.457-.996 2.2.456-.667.871-1.357 1.311-2.03l1.239-2.07c.83-1.38 1.607-2.783 2.372-4.187a122.187 122.187 0 0 0 2.23-4.27c.712-1.44 1.43-2.879 2.064-4.389ZM117.417 74.468c1.821-.107 3.636-.29 5.439-.484 1.802-.195 3.611-.436 5.414-.678 1.803-.242 3.6-.525 5.391-.844l2.681-.484c.896-.182 1.779-.347 2.681-.554-.913.047-1.821.136-2.728.207l-2.717.277c-1.809.189-3.611.43-5.408.678-1.797.248-3.6.525-5.392.844-1.791.318-3.582.636-5.361 1.037ZM147.362 58.23c-2.604.59-5.183 1.31-7.758 2.011a441.821 441.821 0 0 0-7.709 2.2c-2.563.75-5.119 1.54-7.657 2.36l-3.814 1.238c-1.263.437-2.533.85-3.79 1.31 1.305-.301 2.593-.65 3.891-.968l3.872-1.044a393.211 393.211 0 0 0 7.711-2.206c2.568-.755 5.119-1.54 7.663-2.359 2.544-.82 5.053-1.64 7.591-2.542ZM125.838 23c-1.719 2.088-3.38 4.223-5.028 6.364a370.668 370.668 0 0 0-4.87 6.488 363.918 363.918 0 0 0-4.745 6.577l-2.318 3.32c-.754 1.127-1.525 2.236-2.254 3.374.865-1.044 1.696-2.106 2.544-3.161l2.485-3.203a332.731 332.731 0 0 0 4.869-6.488 372.285 372.285 0 0 0 4.745-6.577c1.559-2.217 3.096-4.43 4.572-6.694ZM112.423 57.929c2.823-1.35 5.604-2.778 8.386-4.211 2.782-1.434 5.527-2.92 8.303-4.383 2.776-1.462 5.492-2.99 8.214-4.53l4.075-2.312c1.346-.796 2.705-1.568 4.039-2.359-1.412.673-2.806 1.386-4.211 2.076l-4.152 2.136c-2.775 1.433-5.527 2.949-8.303 4.382-2.776 1.433-5.486 2.99-8.208 4.53-2.722 1.54-5.468 3.055-8.143 4.671Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M113.148 108.624a.7.7 0 0 0-.701.698v9.761a.7.7 0 0 0 .701.698h11.218a.7.7 0 0 0 .701-.698v-9.761a.7.7 0 0 0-.701-.698h-11.218Zm2.103 4.184h2.103v2.092h-2.103v-2.092Zm7.012 0h-4.207v2.092h4.207v-2.092Zm-7.012 2.789h7.012v2.092h-7.012v-2.092Zm-1.402 2.789v-6.275h9.816v6.275h-9.816Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "marketing_svg__b",
    width: 75.585,
    height: 75.439,
    x: 82.17,
    y: 82.284,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.402,
    dy: 5.606
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.263
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11178_22619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_11178_22619",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "marketing_svg__c",
    width: 49.055,
    height: 48.96,
    x: 14.565,
    y: 22.47,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.91,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.959
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11178_22619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_11178_22619",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "marketing_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h163v138H.5z"
  })))));
};
export default SvgMarketing;